/**
 * Central storage key constants for ANCHOR MODE compliance
 * Use these instead of magic strings to avoid typos and enable refactoring
 * 
 * Usage:
 * import { STORAGE_KEYS } from 'constants/STORAGE_KEYS';
 * const { value, setValue } = useStorageState(STORAGE_KEYS.MAINTENANCE_HISTORY, []);
 */

export const STORAGE_KEYS = {
  // Core modules
  MAINTENANCE_HISTORY: 'maintenance_history',
  EQUIPMENT_RECORDS: 'equipment_records',
  DAILY_CHECKS: 'daily_checks',
  CREW_MEMBERS: 'crewMembers',
  DRILLS: 'drills',
  DEFECTS: 'defects',
  
  // Logbook & Voyage
  LOG_ENTRIES: 'log_entries',
  VOYAGES: 'voyages',
  PASSAGE_PLANS: 'passage_plans',
  
  // Safety & Compliance
  INCIDENTS: 'incidents',
  RISK_ASSESSMENTS: 'risk_assessments',
  HOURS_OF_REST: 'hours_of_rest',
  HOR_PATTERNS: 'hor_patterns',
  EQUIPMENT_CHECKS: 'equipmentChecks',
  AUDITS: 'audits',
  COMPLIANCE_ITEMS: 'compliance_items',
  SMS_DOCUMENTS: 'sms_documents',
  
  // Settings & Configuration
  VESSEL_SETTINGS: 'vesselSettings',
  USER_PREFERENCES: 'userPreferences',
  
  // Audit & History
  AUDIT_LOG: 'auditLog',
  SAFETY_CHECK_HISTORY: 'safetyCheckHistory',

  // Operations Module
  PILOT_TRANSFERS: 'pilot_transfers',
  TOWING_OPERATIONS: 'towing_operations',
  DIVING_OPERATIONS: 'diving_operations',
  CHECKLIST_TEMPLATES: 'checklist_templates',
  CHECKLIST_COMPLETIONS: 'checklist_completions',
  VOYAGE_PHASES: 'voyage_phases'
};

// Export individual keys for convenience
export const {
  MAINTENANCE_HISTORY,
  EQUIPMENT_RECORDS,
  DAILY_CHECKS,
  CREW_MEMBERS,
  DRILLS,
  DEFECTS,
  LOG_ENTRIES,
  VOYAGES,
  PASSAGE_PLANS,
  INCIDENTS,
  RISK_ASSESSMENTS,
  HOURS_OF_REST,
  HOR_PATTERNS,
  EQUIPMENT_CHECKS,
  VESSEL_SETTINGS,
  USER_PREFERENCES,
  AUDIT_LOG,
  SAFETY_CHECK_HISTORY,
  // Operations Module
  PILOT_TRANSFERS,
  TOWING_OPERATIONS,
  DIVING_OPERATIONS,
  CHECKLIST_TEMPLATES,
  CHECKLIST_COMPLETIONS,
  VOYAGE_PHASES,
  // Safety & Compliance (Days 4-5)
  AUDITS,
  COMPLIANCE_ITEMS,
  SMS_DOCUMENTS
} = STORAGE_KEYS;